import styled from "@emotion/styled";
import type { PropsWithChildren } from "react";

import { HEADER_HEIGHT, HEADER_SIDE_PADDING } from "../utilities/constants";
import { useHeaderBarContext } from "./AppContext";

const HeaderBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  min-height: ${HEADER_HEIGHT}px;
  max-height: ${HEADER_HEIGHT}px;
  max-width: 100%;

  padding: 0 ${HEADER_SIDE_PADDING}px;

  color: ${({ theme }) => theme.generalTextIcon};
  background-color: ${({ theme }) => theme.surfaceVariant};

  overflow: hidden;
`;

export const HeaderBar = ({ children }: PropsWithChildren) => {
  const { renderPrefix, renderSuffix } = useHeaderBarContext();

  return (
    <HeaderBarContainer data-test="header-bar-container">
      <div data-test="prefix-container">{renderPrefix()}</div>
      {children}
      <div data-test="suffix-container">{renderSuffix()}</div>
    </HeaderBarContainer>
  );
};
